import { ContractType } from '../enums/contract-statuses';

export class ContractsDropdownFilter {
  clientCompanyId: number;
  contractType: ContractType;
}
